import React, { useState } from 'react';
import { Button, Dialog, DialogActions, Paper, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { formatWindows, ScheduleItem } from '../../../../../main/apps/ConfiguredApps/user-management/common';
import Windows from './Windows';

const WindowsWithOverview = ({ name, overviewProps, ...rest }) => {
    const { getValues } = useFormContext();
    const [open, setOpen] = useState(false);

    const { resource = 'pickup', noLabel = false } = overviewProps ?? {};

    const windows = getValues(name);
    const formattedSchedule = formatWindows(windows);

    const closeDialog = () => {
        setOpen(false);
    };

    return (
        <>
            {!noLabel && (
                <Typography variant="body1" fontWeight={600} sx={{ opacity: 0.8 }}>
                    {resource.toUpperCase()} SCHEDULE
                </Typography>
            )}
            {formattedSchedule?.length ? (
                formattedSchedule.map((window, index) => <ScheduleItem key={`window_key${index * 2}`} {...window} />)
            ) : (
                <Typography variant="body2" sx={{ my: 1, fontWeight: 'bold' }}>
                    No {resource.toLowerCase()} schedule has been set
                </Typography>
            )}
            <Button onClick={() => setOpen(true)} variant="outlined">
                Add/Edit Schedule
            </Button>
            <Dialog maxWidth="lg" open={open} onClose={() => closeDialog()} keepMounted>
                <Paper sx={{ m: 3, p: 3 }}>
                    <Windows name={name} {...rest} />
                </Paper>
                <DialogActions>
                    <Button onClick={() => closeDialog()} variant="outlined">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default WindowsWithOverview;
